export default "__VITE_ASSET__Dw1p0mzo__"